import { render } from "./LinkDisplay.vue?vue&type=template&id=23fd7c16&scoped=true"
import script from "./LinkDisplay.vue?vue&type=script&lang=js"
export * from "./LinkDisplay.vue?vue&type=script&lang=js"

import "./LinkDisplay.vue?vue&type=style&index=0&id=23fd7c16&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23fd7c16"]])

export default __exports__